import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormControl,
  ValidatorFn,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

export type InputType = 'text' | 'textarea';

export interface IFormModalField {
  name: string;
  label: string;
  value: string;
  type: InputType;
  required: boolean;
  validators: ValidatorFn[];
}

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
})
export class FormModalComponent implements OnInit {
  @Input() text: string;
  @Input() title: string;
  @Input() formDefinition: IFormModalField[];

  form: UntypedFormGroup;
  params: any = {};

  constructor(
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({});
    this.createFormControls();
  }

  createFormControls(): void {
    this.formDefinition.forEach(field => {
      const validators = field.validators || [];
      if (field.required) {
        validators.push(Validators.required);
      }
      this.form.addControl(
        field.name,
        new FormControl(field.value, validators)
      );
    });
  }

  validate(): void {
    if (this.form.valid) {
      this.activeModal.close(this.form.getRawValue());
    }
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }
}
